class DraggableCardsController {
  constructor(root) {
    this.root = root;
    this.sectionId = root.dataset.section;
    this.container = root;
    this.cards = Array.from(this.container.querySelectorAll(".draggable-card"));
    this.tabs = document.querySelectorAll(
      `.draggable-cards-section[data-section-id="${this.sectionId}"] .draggable-cards__tab`
    );
    this.resetBtn = document.querySelector(
      `.draggable-cards-section[data-section-id="${this.sectionId}"] [data-action="reset"]`
    );
    this.activeSet =
      root.closest(".draggable-cards-section")?.dataset.defaultSet ||
      "imprezowa";
    this.stack = [];
    this.activeIndex = 0;
    this.hiddenDuringDrop = [];

    this.init();
  }

  init() {
    this.bindTabs();
    this.bindArrows();
    this.applySet(this.activeSet);
  }

  getTransformForIndex(index) {
    const offset = Math.min(12, index * 4);
    const tilt = index === 0 ? 0 : index % 2 ? -2 : 2;
    return `translate3d(${offset}px, ${offset}px, 0) rotate(${tilt}deg)`;
  }

  bindTabs() {
    this.tabs.forEach((tab) => {
      tab.setAttribute(
        "aria-selected",
        String(tab.dataset.set === this.activeSet)
      );
      tab.addEventListener("click", () => {
        this.applySet(tab.dataset.set);
      });
    });
  }

  bindArrows() {
    const sectionRoot = document.querySelector(
      `.draggable-cards-section[data-section-id="${this.sectionId}"]`
    );
    const left = sectionRoot?.querySelector('[data-arrow="left"]');
    const right = sectionRoot?.querySelector('[data-arrow="right"]');
    left?.addEventListener("click", () => this.prev());
    right?.addEventListener("click", () => this.next());
  }

  applySet(setName) {
    this.activeSet = setName;
    this.tabs.forEach((t) =>
      t.setAttribute("aria-selected", String(t.dataset.set === setName))
    );
    // Visibility: show only active set cards, hide others completely
    this.cards.forEach((c) => {
      const isInSet = c.dataset.set === setName;
      c.hidden = !isInSet;
      c.classList.remove("is-active");
      if (!isInSet) {
        c.style.pointerEvents = "none";
        c.style.opacity = "0";
        c.style.zIndex = "0";
      }
    });
    // filter cards for active set
    this.stack = this.cards.filter((c) => c.dataset.set === setName);
    // Ensure proper z-index layering (top is activeIndex=0)
    this.stack.forEach((c, i) => {
      c.style.zIndex = String(this.stack.length - i);
    });
    // reset ordering with slight offsets for depth feel
    this.stack.forEach((c, i) => {
      const inner = c.querySelector(".draggable-card__inner");
      if (inner) {
        inner.style.transform = this.getTransformForIndex(i);
        inner.style.opacity = "1";
      }
      c.style.opacity = i === 0 ? "1" : "0.96";
      c.style.zIndex = String(this.stack.length - i);
      c.classList.toggle("is-active", i === 0);
      c.style.pointerEvents = i === 0 ? "auto" : "none";
    });
    this.activeIndex = 0;
    this.attachDrag();
  }

  attachDrag() {
    this.detachDrag();
    this.activeCard = this.stack[this.activeIndex];
    if (!this.activeCard) return;

    const surface =
      this.activeCard.querySelector(".draggable-card__inner") ||
      this.activeCard;
    let startX = 0,
      currentX = 0,
      dragging = false;

    const onStart = (x) => {
      dragging = true;
      startX = x;
      currentX = x;
      surface.style.transition = "none";
    };

    const onMove = (x) => {
      if (!dragging) return;
      currentX = x;
      const dx = currentX - startX;
      const rot = Math.max(-10, Math.min(10, dx / 20));
      surface.style.transform = `translate3d(${dx}px, 0, 0) rotate(${rot}deg)`;
    };

    const onEnd = () => {
      if (!dragging) return;
      dragging = false;
      const dx = currentX - startX;
      const threshold = Math.max(80, surface.offsetWidth * 0.2);
      surface.style.transition = "transform 220ms ease, opacity 220ms ease";
      if (Math.abs(dx) >= threshold) {
        const dir = dx > 0 ? 1 : -1;
        // 1) pokaż następną kartę NA PEWNO na wierzchu; zablokuj resztę nad nią, by uniknąć mignięcia trzeciej
        const nextIndex = (this.activeIndex + 1) % this.stack.length;
        const nextCard = this.stack[nextIndex];
        const topZ = this.stack.length + 100;
        if (nextCard) {
          nextCard.classList.add("is-active");
          nextCard.style.pointerEvents = "auto";
          nextCard.style.opacity = "1";
          nextCard.style.zIndex = String(topZ);
          // płynne przejście drugiej karty w pozycję pierwszej
          const nextInner = nextCard.querySelector(".draggable-card__inner");
          if (nextInner) {
            nextInner.style.transition = "transform 260ms ease";
            nextInner.style.transform = this.getTransformForIndex(0);
          }
        }
        // Ustaw bardzo niski z-index dla wszystkich pozostałych poza animowaną i next
        const others = [];
        this.stack.forEach((card) => {
          if (card !== nextCard && card !== this.activeCard) {
            card.style.zIndex = "0";
            card.style.visibility = "hidden";
            others.push(card);
          }
        });
        this.hiddenDuringDrop = others;
        // 2) animuj bieżącą kartę pod spód stosu (do transform spodniego indeksu)
        const finalTransform = this.getTransformForIndex(this.stack.length - 1);
        surface.style.transition = "transform 260ms ease, opacity 260ms ease";
        surface.style.opacity = "0.96";
        surface.style.transform = finalTransform;
        this.activeCard.style.zIndex = String(topZ - 1);
        // 3) po animacji przepnij na dół danych i DOM
        setTimeout(() => this.restackToBottom(), 260);
      } else {
        surface.style.transform = "translate3d(0,0,0) rotate(0deg)";
      }
    };

    // Pointer events
    const onPointerDown = (e) => {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      surface.setPointerCapture?.(e.pointerId);
      onStart(e.clientX);
      e.preventDefault();
    };
    const onPointerMove = (e) => onMove(e.clientX);
    const onPointerUp = () => onEnd();

    // Touch fallback
    const onTouchStart = (e) => onStart(e.touches[0].clientX);
    const onTouchMove = (e) => onMove(e.touches[0].clientX);
    const onTouchEnd = () => onEnd();

    // Mouse fallback
    const onMouseDown = (e) => {
      if (e.button === 0) onStart(e.clientX);
    };
    const onMouseMove = (e) => onMove(e.clientX);
    const onMouseUp = () => onEnd();

    surface.addEventListener("pointerdown", onPointerDown);
    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", onPointerUp);

    surface.addEventListener("touchstart", onTouchStart, { passive: true });
    window.addEventListener("touchmove", onTouchMove, { passive: true });
    window.addEventListener("touchend", onTouchEnd, { passive: true });

    surface.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);

    this.detachDrag = () => {
      surface.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("pointermove", onPointerMove);
      window.removeEventListener("pointerup", onPointerUp);
      surface.removeEventListener("touchstart", onTouchStart);
      window.removeEventListener("touchmove", onTouchMove);
      window.removeEventListener("touchend", onTouchEnd);
      surface.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }

  detachDrag() {}

  revealNext() {
    const current = this.stack[this.activeIndex];
    if (current) {
      current.classList.remove("is-active");
      current.style.pointerEvents = "none";
      current.style.opacity = "0";
      current.style.zIndex = "1";
    }
    this.activeIndex += 1;
    const next = this.stack[this.activeIndex];
    if (next) {
      next.classList.add("is-active");
      next.style.pointerEvents = "auto";
      next.style.opacity = "1";
      next.style.zIndex = "2";
      this.attachDrag();
    }
  }

  restackToBottom() {
    // move current active card to bottom of stack and cycle index (within current set only)
    const current = this.stack[this.activeIndex];
    if (!current) return;
    const inner = current.querySelector(".draggable-card__inner");
    if (inner) inner.style.transform = "translate3d(0,0,0) rotate(0deg)";

    // Send current to end of array, then re-render stack and DOM order
    const moved = this.stack.splice(this.activeIndex, 1)[0];
    this.stack.push(moved);

    // Append only within visible set order: place moved after last visible card
    if (moved && moved.parentNode === this.container) {
      const lastVisible = [
        ...this.container.querySelectorAll(".draggable-card:not([hidden])"),
      ].pop();
      if (lastVisible) lastVisible.after(moved);
      else this.container.appendChild(moved);
    }

    this.stack.forEach((card, i) => {
      const isTop = i === this.activeIndex;
      card.style.zIndex = String(this.stack.length - i);
      card.classList.toggle("is-active", isTop);
      card.style.pointerEvents = isTop ? "auto" : "none";
      card.style.opacity = isTop ? "1" : "0.96";
      const inner = card.querySelector(".draggable-card__inner");
      if (inner) inner.style.transform = this.getTransformForIndex(i);
    });

    // Przywróć widoczność kart ukrytych na czas dropa, po pełnym przetasowaniu
    if (this.hiddenDuringDrop && this.hiddenDuringDrop.length) {
      this.hiddenDuringDrop.forEach((c) => {
        c.style.visibility = "visible";
      });
      this.hiddenDuringDrop = [];
    }

    this.attachDrag();
  }

  next() {
    this.revealNext();
  }
  prev() {
    const prevIndex = Math.max(0, this.activeIndex - 1);
    if (prevIndex === this.activeIndex) return;
    const current = this.stack[this.activeIndex];
    const prev = this.stack[prevIndex];
    if (current) {
      current.classList.remove("is-active");
      current.style.pointerEvents = "none";
      current.style.opacity = "0";
      current.style.zIndex = "1";
      current.querySelector(".draggable-card__inner").style.transform =
        "translate3d(0,0,0) rotate(0deg)";
    }
    if (prev) {
      this.activeIndex = prevIndex;
      prev.classList.add("is-active");
      prev.style.pointerEvents = "auto";
      prev.style.opacity = "1";
      prev.style.zIndex = "2";
      this.attachDrag();
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll('[data-component="draggable-cards"]')
    .forEach((root) => new DraggableCardsController(root));
});
